// context.js
import { createContext } from "react";

export const homeContext = createContext();
export const bookContext = createContext();
export const chapterContext = createContext();
export const tab1Context = createContext();
export const switch1Context = createContext();
export const verseLabelArrowsContext = createContext();
export const verseContext = createContext();
export const stack1Context = createContext();
export const popoverContext = createContext();
export const searchContext = createContext();
export const search2Context = createContext();
export const chipArrayContext = createContext();
export const searchCriteriaContext = createContext();
export const noteContext = createContext();
export const noteBookmarkListContext = createContext();